module.exports = __webpack_public_path__ + "assets/images/08a18ac078488310f6803710ac943d46.png";